import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { Container, Header, Image, Panel, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AppBadges from '../AppBadges';
import styles from './HeroAppDownload.module.css';

const cx = classnames.bind(styles);

export const IS_MOBILE_DEVICE = gql`
  query isMobileDevice {
    config {
      isMobile
    }
  }
`;

export default function HeroAppDownload({ useH1Header }) {
  const { t } = useTranslation('marketing');
  const { data } = useQuery(IS_MOBILE_DEVICE);
  const isOnMobileDevice = data?.config?.isMobile;

  let linkContent;
  if (isOnMobileDevice) {
    linkContent = (
      <AppBadges analyticsScreenName="App_Page" fluid showReviewSections />
    );
  } else {
    linkContent = (
      <div className={cx('qrCodeContainer')}>
        <Image
          alt={t('heroAppDownload.qrCodeAlt', { ns: 'marketing' })}
          className={cx('qrCode')}
          src="https://static.gasbuddy.com/web/download-app-qr-code.svg"
        />
      </div>
    );
  }

  return (
    <div className={cx('heroImageBackground')}>
      <Container>
        <Panel className={cx('appDownloadContent')} color="white" rounded={false}>
          <Header as={useH1Header ? 'h1' : 'h2'} className={cx('header')} color="midnight">
            {t('heroAppDownload.header', { ns: 'marketing' })}
          </Header>
          <Text as="p" className={cx('subHeader')} color="midnight">
            {isOnMobileDevice
              ? t('heroAppDownload.subHeaderMobile', { ns: 'marketing' })
              : t('heroAppDownload.subHeaderDesktop', { ns: 'marketing' })}
          </Text>
          <br />
          {linkContent}
        </Panel>
      </Container>
    </div>
  );
}

HeroAppDownload.propTypes = {
  useH1Header: PropTypes.bool,
};

HeroAppDownload.defaultProps = {
  useH1Header: false,
};
